import { useQuery } from '@tanstack/react-query';
import fetch from './fetch';

/**
 * @param {string} stockCode
 */
function usePrice(stockCode, enabled = true) {
  const { cb, key } = fetch(stockCode);
  const { data, isSuccess, refetch } = useQuery(key, cb, {
    enabled: !!stockCode && stockCode.toLowerCase() !== 'undefined' && enabled,
    // to avoid excessive calls, this will be updated by websocket anyways
    staleTime: 5 * 60 * 1000, // 5 minutes
  });

  return { data, isSuccess, refetch };
}

export default {
  usePrice,
};
